import { createSlice } from '@reduxjs/toolkit';

export const passwordSlice = createSlice({
  name: 'password',
  initialState: {
    isSaving: false,
    aplications_select_list: [],
  },
  reducers: {
    setSaving: (state) => {
      state.isSaving = true;
    },
    stopSaving: (state) => {
      state.isSaving = false;
    },
    setAplicationsList: (state, { payload }) => {
      state.aplications_select_list = payload;
    },
  },
});

export const { setSaving, stopSaving, setAplicationsList } = passwordSlice.actions;
